<template>
    <div>
        <template>
            <template v-if="purchase.actions.customer.contract === 'create'">
                <b-overlay :show="isDataSending" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <form-row-contract-upload v-model="form.attachment" :disabled="!$store.getters.getCanSign" :label-cols-lg="3" :v="$v.form.attachment" send-title="Отправить контракт" title="Контракт" with-send @send="send">
                        <template #other>
                            <fl44-unknown-volume-send-decline-contract-button :purchase-item="purchase" class="ml-2" @refresh="$emit('refresh', $route.hash !== '' ? '' : null)" />
                        </template>
                    </form-row-contract-upload>
                </b-overlay>
                <template v-if="!$store.getters.getCanSign">
                    <div v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">
                        Для действия требуется загрузить/заменить МЧД на странице:
                        <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link>
                    </div>
                    <div v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Отправка контракта возможна только при авторизации при помощи ЭЦП</div>
                </template>
            </template>
            <private-fl44-unknown-volume-contract-sign-form-customer v-else-if="purchase.actions.customer.contract === 'sign'" :purchase="purchase" @refresh="$emit('refresh')" />
            <template v-else-if="purchase.actions.customer.contract === 'reply'">
                <b-row>
                    <b-col md="10">
                        <text-header id="atmo-disputes-resolution">Согласование разногласий по контракту</text-header>
                    </b-col>
                </b-row>
                <b-overlay :show="isDataSending" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <form-row-contract-upload v-model="formDisagreement.contract" :label-cols-lg="3" :v="$v.formDisagreement.contract" title="Новая редакция контракта" />
                    <form-row-contract-upload v-model="formDisagreement.disagreement" :label-cols-lg="3" :v="$v.formDisagreement.disagreement" title="Ответ на протокол разногласий" />
                    <form-row-edit-textarea v-model="formDisagreement.comment" :v="$v.formDisagreement.comment" label="Комментарий" />
                </b-overlay>
                <b-overlay :show="isDataSending" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-btn :disabled="!$store.getters.getCanSign || $v.formDisagreement.$invalid" class="mr-2" variant="custom-green" @click="showDisagreementModal = true">Подписать и отправить ответ на протокол разногласий</b-btn>
                    <fl44-unknown-volume-sign-decline-contract-button :purchase-item="purchase" @refresh="$emit('refresh')" />
                </b-overlay>
                <template v-if="!$store.getters.getCanSign">
                    <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link></span>
                    <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</span>
                </template>
                <sign-file-modal
                    v-if="formDisagreement.disagreement"
                    :attachment="formDisagreement.disagreement"
                    :show="showDisagreementModal"
                    :is-sending="isDataSending"
                    title="Отправка подписанного ответа на протокол разногласий"
                    @close="showDisagreementModal = false"
                    @submit="storeSignedDisagreement" />
            </template>
        </template>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { getCertificate } from 'crypto-pro';
import FileDownload from 'js-file-download';
import FormRowContractUpload from '@/components/common/form-rows/form-row-contract-upload.vue';
import PrivateFl44UnknownVolumeContractSignFormCustomer from '@/components/products/fl44-unknown-volume/partials/private-fl44-unknown-volume-contract-sign-form-customer.vue';
import Fl44UnknownVolumeSendDeclineContractButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-send-decline-contract-button.vue';
import Fl44UnknownVolumeSignDeclineContractButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-sign-decline-contract-button.vue';

export default {
    name: 'private-fl44-unknown-volume-contract-customer-block',
    components: { Fl44UnknownVolumeSignDeclineContractButton, Fl44UnknownVolumeSendDeclineContractButton, PrivateFl44UnknownVolumeContractSignFormCustomer, FormRowContractUpload },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showDisagreementModal: false,
            form: {
                attachment: null
            },
            formDisagreement: {
                contract: null,
                disagreement: null,
                comment: ''
            },
            isDataSending: false
        };
    },
    validations() {
        return {
            form: {
                attachment: {
                    required
                }
            },
            formDisagreement: {
                contract: {
                    required
                },
                disagreement: {
                    required
                },
                comment: {
                    required
                }
            }
        };
    },
    methods: {
        async send() {
            this.isDataSending = true;
            if (await this.$api.products.fl44UnknownVolume.contracts.store(this.purchase.id, this.form.attachment)) {
                this.$emit('refresh', null);
            }
            this.isDataSending = false;
        },
        async storeSignedDisagreement(signature) {
            this.isDataSending = true;
            const data = {
                certificate: await getCertificate(this.$store.getters.getCurrentThumbprint),
                comment: this.formDisagreement.comment,
                contract_attachment_id: this.formDisagreement.contract.id,
                is_importable: this.formDisagreement.contract.is_importable,
                signed_attachment: {
                    id: this.formDisagreement.disagreement.id,
                    md5: signature.signature
                }
            };
            const disagreementId = this.purchase.contract.contract_disagreements.find((disagreement) => !disagreement.customer_attachment).id;
            await this.$api.products.fl44UnknownVolume.contracts.storeSignedDisagreement(this.purchase.id, this.purchase.contract.id, 'customer', data, disagreementId)
                .then((result) => {
                    if (result) {
                        this.showDisagreementModal = false;
                        this.$emit('refresh', this.$route.hash !== '#atmo-contract' ? '#atmo-contract' : null);
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        },
        downloadZip() {
            this.$api.products.fl223.contracts
                .downloadZip(this.purchase.id, this.purchase.contract.id, this.purchase.contract.contract_files.find((file) => !file.is_archived).contract_attachment.id)
                .then((response) => {
                    FileDownload(response.data, this.purchase.contract.zip_name);
                })
                .catch((error) => {
                    this.showError(error);
                });
        },
        downloadPdf() {
            this.$api.products.fl223.contracts
                .downloadPrintForm(this.purchase.id, this.purchase.contract.id, this.purchase.contract.contract_files.find((file) => !file.is_archived).contract_attachment.id)
                .then((response) => {
                    FileDownload(response.data, this.purchase.contract.pdf_name);
                })
                .catch((error) => {
                    this.showError(error);
                });
        }
    }
};
</script>
